import { normalize, schema } from 'normalizr';
import { taskSchema } from 'data/tasks/schema';
const homeSchema = new schema.Object({
    myTasks: [
        taskSchema
    ]
});
export const homeNormalizer = (data)=>{
    return normalize(data, homeSchema);
};
